import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { Group, Loader, Select } from "@mantine/core";
import Selector from "../../Selectors/Selector";
import { findWorkflow, getWorkflows } from "../../../api/WorkflowAPI";
import { getNodeDetails } from "../../../pages/protected/workflows/CreateCampaign/flow/flowSettings";
import { useFlowStore } from "../../../stores/WorkflowStore";

const FilterWorkflowStep = ({ setValue, value, isMobile, readOnly }) => {
  const lang = useLanguage((s) => s.language);
  const workflowOptions = useFlowStore((s) => s.workflows);
  const [loading, setLoading] = useState(false);
  const [loadingSteps, setLoadingSteps] = useState(false);

  const [workflow, setWorkflow] = useState(
    value
      ? workflowOptions.find((x) => x.id.toString() === value.split("_")[0])
      : null
  );
  const [stepOptions, setStepOptions] = useState([]);

  const [step, setStep] = useState(null);

  const getOptions = () => {
    setLoading(true);
    getWorkflows().finally(() => setLoading(false));
  };

  const findWorkflowSteps = (id) => {
    setLoadingSteps(true);
    findWorkflow(id)
      .then((r) => {
        let result = r.data.workflow_profile?.steps
          .filter((x) => x.step_type === "action")
          .map((x) => ({
            label: `${getNodeDetails(x.action_type).label} #${x.step_id.id}`,
            value: x.step_id.id.toString(),
          }));
        setStepOptions(result);
        if (!result.find((x) => x.value === step))
          setStep(result[0]?.value || null);
      })
      .finally(() => setLoadingSteps(false));
  };

  const handleWorkflowChange = (v) => {
    setWorkflow(v);
    findWorkflowSteps(v.id);
  };

  const handleStepChange = (v) => {
    setStep(v);
  };

  const wOptions = useMemo(() => {
    return [
      {
        label: "Scénarios",
        options: workflowOptions.map((x) => ({
          ...x,
          option_name: `${x.name} #${x.id}`,
        })),
      },
    ];
  }, [workflowOptions]);

  useEffect(() => {
    if (step && workflow) {
      // let result = workflow.id + "_" + step;
      setValue(step);
    }
  }, [setValue, step, workflow]);

  useEffect(() => {
    if (value && !step && workflow) {
      setLoadingSteps(true);
      findWorkflow(workflow.id)
        .then((r) => {
          let result = r.data.workflow_profile?.steps
            .filter((x) => x.step_type === "action")
            .map((x) => ({
              label: `${getNodeDetails(x.action_type).label} #${x.step_id.id}`,
              value: x.step_id.id.toString(),
            }));
          setStepOptions(result);
          setStep(result.find((x) => x.value === value.split("_")[1])?.value);
        })
        .finally(() => setLoadingSteps(false));
    }
  }, [value, step, workflow]);

  return (
    <Group gap={"xs"}>
      <Selector
        options={wOptions}
        loading={loading}
        value={workflow?.id || null}
        onChange={handleWorkflowChange}
        placeholder={"Scénario"}
        required
        onDropdownOpen={getOptions}
        rightOptionSection={(item) => {
          return (
            item?.id && (
              <span style={{ fontSize: 10, opacity: 0.35, width: 50 }}>#{item?.id}</span>
            )
          );
        }}
        unclearable
        size={"sm"}
      readOnly={readOnly}
      />
      <Select
        data={stepOptions}
        value={step}
        placeholder={"Action"}
        onChange={handleStepChange}
        required
        w={"100%"}
        disabled={loadingSteps}
        rightSection={loadingSteps && <Loader size={18} />}
      readOnly={readOnly}
      />
    </Group>
  );
};

export default FilterWorkflowStep;
